export default {"src":"/_next/static/media/underlines-7.6cebb2ff.svg","height":23,"width":185,"blurWidth":0,"blurHeight":0};